import { ApplicationState } from 'framework/applicationState';
import { Event } from 'framework/entities/events';
import { RuleDefinition, RulesConfiguration } from 'controls/queryBuilder/ruleDefinition';

type IncidentCounterEventArgs = {
	accountId: string;
	includeSubaccounts?: boolean;
	filters?: RuleDefinition;
};

const eventType = 'IncidentCounter';

export class IncidentCounterEvent extends Event {
	incidentCounter: number;

	static is(e: Event): e is IncidentCounterEvent {
		return e.eventType == eventType;
	}

	static subscription(args: IncidentCounterEventArgs) {
		return {
			eventType: eventType,
			accountId: args.accountId,
			includeSubaccounts: args.includeSubaccounts ?? ApplicationState.includeSubaccounts,
			filter: args.filters,
		};
	}
}
